import { useTranslation } from 'react-i18next';
import { PageHeader } from '../../../components/PageHeader';
import { PageContent, PageLayout } from '../../../layout';
import { ReceivedMessagesTable } from './components/ReceivedMessagesTable';

export const ReceivedMessages = () => {
  const { t } = useTranslation('page-admin-received-messages');
  return (
    <PageLayout>
      <PageHeader backRouteTo={''} title={t('title')} />
      <PageContent sx={{ alignItems: 'flex-start' }}>
        <ReceivedMessagesTable />
      </PageContent>
    </PageLayout>
  );
};
